import styled from 'styled-components';

/** One `1em` tall, its width from the asset's proportions (1200 × 241.4). */
export const Root = styled.svg`
  display: block;
  flex: 0 0 auto;
  height: 1em;
  width: auto;
  aspect-ratio: 1200 / 241.4;
`;
